import { gql } from '@grandvisionhq/graphql';

const commercialCategoryFragment = gql`
  fragment CommercialCategoryFragment on CommercialCategory {
    ancestors {
      key
      name
    }
    key
    name
  }
`;
const mediaFragment = gql`
  fragment mediaFragment on Media {
    images {
      url
      dimensions {
        w
        h
      }
      label
    }
  }
`;
const sourceFragment = gql`
  fragment sourceFragment on ProductAssetSource {
    contentType
    key
    uri
  }
`;
const assetFragment = gql`
  fragment assetFragment on ProductAsset {
    name
    nameAllLocales {
      locale
      value
    }
    sources {
      ...sourceFragment
    }
    tags
  }
  ${sourceFragment}
`;
const frameFeaturesFragment = gql`
  fragment frameFeaturesFragment on FrameFeatures {
    bridgeWidth
    color
    colorAllLocales {
      locale
      value
    }
    material
    materialAllLocales {
      locale
      value
    }
    templeLength
    type
    typeAllLocales {
      locale
      value
    }
    width
    shape {
      displayName
      displayNameAllLocales {
        locale
        value
      }
      shape
    }
    size {
      displayName
      size
    }
    templeType
    templeColor
  }
`;
const lensFeaturesFragment = gql`
  fragment lensFeaturesFragment on LensFeatures {
    isPolarized
    isGlazeble
    isGradient
    isMirror
    uvRaysProtection
    lensWidth
    lensHeight
    lensColor
  }
`;

export { assetFragment, commercialCategoryFragment, frameFeaturesFragment, lensFeaturesFragment, mediaFragment, sourceFragment };
//# sourceMappingURL=small-fragments.js.map
